import styled from "styled-components";

import { DropdownGraphContainer } from "../../../components/StyledComponents";

export const CircleDetail = styled.div`
  font-size: ${props => (props.size === "large" ? "10px" : "9px")};
  line-height: ${props => (props.size === "large" ? "14px" : "12px")};

  margin: 13.3px auto 20px auto;
  color: ${props => props.theme.text};

  @media (min-width: 1800px) {
    font-size: ${props => (props.size === "large" ? "18px" : "14px")};
    line-height: ${props => (props.size === "large" ? "17px" : "20px")};
  }
`;

export const FirstDropdownGraph = styled.div`
  cursor: pointer;
  margin: 0 auto;
  height: 55px;
  width: 55px;

  @media (min-width: 1800px) {
    height: 80px;
    width: 80px;
  }
`;

export const DropdownGraphContainer1 = styled(DropdownGraphContainer)`
  flex-direction: row-reverse;
  justify-content: flex-start;
  margin: 0 -5%;
`;

export const DropdownGraphChild = styled.div`
  opacity: ${props => (props.selected ? 1 : 0.3)};

  width: 33.3333%;
  text-align: center;
`;

export const SecondDropdownGraph = styled.div`
  cursor: pointer;
  margin: 0 auto;
  height: 42.5px;
  width: 42.5px;

  @media (min-width: 1800px) {
    height: 55px;
    width: 55px;
  }
`;

export const DropdownGraphContainer2 = styled(DropdownGraphContainer)`
  margin: 0 -8%;
`;
